export default class DateUtils {

    static transormarDataParaModelo(data: any): any {
        if (data && data.length === 10) {
            const dateRegexPart = /([0-9]{2})(-|\/)([0-9]{2})(-|\/)([0-9]{4})/;
            const dateRegexExec = dateRegexPart.exec(data);
            if (dateRegexExec && dateRegexExec.length >= 5) {
                return new Date(parseInt(dateRegexExec[5], 10), parseInt(dateRegexExec[3], 10) - 1, parseInt(dateRegexExec[1], 10));
            }
        }

        return data.toString();
    }

    static transormarDataParaModeloMesAno(data: any) : any {
        if (data && data.length === 7) {
            const dateRegexPart = /([0-9]{2})(-|\/)([0-9]{4})/;
            const dateRegexExec = dateRegexPart.exec(data);
            if (dateRegexExec && dateRegexExec.length >= 3) {
                return new Date(parseInt(dateRegexExec[3], 10), parseInt(dateRegexExec[1], 10) - 1, 1);
            }
        }

        return data.toString();
    }

    static formatarData_YYYY_MM_DD(date:any): string {
        const d = new Date(date);
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const day =  d.getDate().toString().padStart(2, '0');
        const year = d.getFullYear();

        return [year, month, day].join('-');
    }

    static formatarCompetencia(valor: number): string {

        return this.formatarData_AAAAMM_Para_MM_AAAA(valor.toString());

    }

    static formatarData_AAAAMMDD_Para__DD_MM_AAAA(dataString: string | null): string {
        if (!dataString || dataString.length !== 8) {
          return ''; // Retorna vazio se for inválido
        }
  
        const ano = dataString.substring(0, 4);
        const mes = dataString.substring(4, 6);
        const dia = dataString.substring(6, 8);
  
        return `${dia}/${mes}/${ano}`;
    }

    
    static formatarData_AAAAMM_Para_MM_AAAA(dataString: string | number | null): string {
      if (dataString === null){
        return '';
      }

      const valor = dataString.toString();

      if (!/^\d{6}$/.test(valor)) {
        return '';
      }

      const ano = valor.substring(0, 4);
      const mes = valor.substring(4, 6);

      if (Number(mes) < 1 || Number(mes) > 12) {
        return '';
      }

      return `${mes}/${ano}`;
    }

    public static formatarDataString_MM_AAAA_Para_AAAAMM(dataString: string | null): string {
        if (!dataString || dataString.length !== 6) {
          return ''; // Retorna vazio se for inválido
        }
  
        const mes = dataString.substring(0, 2);
        const ano = dataString.substring(2, 6);
  
        return `${ano}${mes}`;
    }    
    
    static getData(dateString:string): Date {
        const timestamp: number = Date.parse(dateString);
        return  new Date(timestamp);
    }

    static converterDeMMAAAAParaAAAAMM(data: string): number {
        
        //Corrigir data no formato MM/yyyy
        if(data.length === 6 && data.charAt(1).match(/(-|\/)/)) {
            data =  `0${data}`;
        }

        if (!data) {
            return 0;
        } else if(data.length === 6) {
            const {mes, ano} = {mes: data.substring(0, 2), ano: data.substring(2, 6)};
            return Number(`${ano}${mes}`);
        } else if(data.length === 7) {
            const separador = data.charAt(2);
            const [mes, ano] = data.split(separador);
            return Number(`${ano}${mes}`);
        } 
        return 0;
    }

    static formatarIsoParaDataHora(dataIso: string | null): string {
      if (!dataIso) {
        return '';
      }
      const d = new Date(dataIso);
      if (isNaN(d.getTime())) {
        return '';
      }
      const dia = d.getDate().toString().padStart(2, '0');
      const mes = (d.getMonth() + 1).toString().padStart(2, '0');
      const ano = d.getFullYear();
      const hora = d.getHours().toString().padStart(2, '0');
      const min = d.getMinutes().toString().padStart(2, '0');
      const seg = d.getSeconds().toString().padStart(2, '0');
      return `${dia}/${mes}/${ano} ${hora}:${min}:${seg}`;
    }

}
